module.exports = __webpack_public_path__ + "static/media/anchor.c25bf5b5.svg";